module.exports = __webpack_public_path__ + "img/i-page2-1.16cf0dbe.png";